import { Link } from 'react-router-dom';
import './Divider.css'
import React from 'react';
import { useTranslation } from 'react-i18next';

const Divider = () => {
  const {t , i18n} = useTranslation()
  return (
    <div className="divider-conrainer">

    <div className='Divider'>
      <h3>
      {t("We’re Ready to Bring Bigger")} <br/>& {t("Stronger Projects")}
      </h3>
      <Link to='bookNow' className='link'>{t("Book now")}</Link>
    </div>
    </div>
  );
}

export default Divider;
